export default "__VITE_ASSET__CzZr16Kv__"